import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';

export default function VenueTypeCapsuleChartHelp() {
    return (
        <IconTooltip>
            <div>
                The first bar in the capsule displays the historical venue types
                that this symbol typically trades in on a market wide level. The
                second bar displays today&apos;s breakdown of venue types that
                this symbol is trading in on a market wide level. The third and
                final bar displays your order&apos;s breakdown of venue types
                that your symbol has traded in. <br />
                <br />
                Click on each bar to flip the capsule and see a detailed
                breakdown of venue type analysis. In the case your order is
                still open/has no fills, the order bar will not be display.
            </div>
        </IconTooltip>
    );
}
